import Vue from 'vue';
import App from './App.vue';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import axios from 'axios';
var instance = axios.create();
instance.defaults.timeout = 10000;
instance.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";

Vue.config.productionTip = false;

Vue.use(VueAwesomeSwiper);

export function testPhone(phone) {//手机正则
  var reg_phone = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
  return reg_phone.test(phone);
}

export function testEmail(email) {
  var reg_email = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
  return reg_email.test(email);
}

new Vue({
  data() {
    return {
      "share": {
        "imgUrl": "https://img.spacesforce.com/logo_2.png",//分享图，默认当相对路径处理，所以使用绝对路径的的话，“http://”协议前缀必须在。
        "desc": "融合型空间资产管理解决方案",//摘要,如果分享到朋友圈的话，不显示摘要。
        "title": '空间原力',//分享卡片标题
        "link": window.location.href,//分享出去后的链接，这里可以将链接设置为另一个页面。
        "success": function () {
          //分享成功后的回调函数
        },
        'cancel': function () {
          // 用户取消分享后执行的回调函数
        }
      }
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      var is_weixin = (function () { return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1 })();
      console.log('is_weixin', is_weixin);
      console.log('is_weixin', window.location.href);
      if (is_weixin) {
        var share = this.share;
        axios
          .post("https://m.spacesforce.com/api/wechat/getJsConfig", {
            url: window.location.href,
          })
          .then(function (response) {
            console.log("response", response);
            if (response.data.error_code == 0) {
              wx_config(response.data.data, share);
            } else {

            }
          })
          .catch(function (error) {
            console.log("error", error);
          });
      }
    }
  },
  render: h => h(App)
}).$mount('#app');

function wx_config(data, share) {
  console.log('data,share', data, share);
  wx.config({
    debug: false,// 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。移动端会通过弹窗来提示相关信息。如果分享信息配置不正确的话，可以开了看对应报错信息
    appId: data.appid,
    timestamp: data.timestamp,
    nonceStr: data.nonceStr,
    signature: data.signature,
    jsApiList: [//需要使用的JS接口列表,分享默认这几个，如果有其他的功能比如图片上传之类的，需要添加对应api进来
      'onMenuShareTimeline',//
      'onMenuShareAppMessage',
      'onMenuShareQQ',
      'onMenuShareWeibo',
      'onMenuShareQZone'
    ]
  });
  wx_share(share);
}
function wx_share(share) {
  wx.ready(function () {
    wx.onMenuShareAppMessage(share);//分享给好友
    wx.onMenuShareTimeline(share);//分享到朋友圈
    wx.onMenuShareQQ(share);//分享给手机QQ
    wx.onMenuShareWeibo(share);
    wx.onMenuShareQZone(share);
  });
  wx.error(function (res) {
    console.log('失败验证', res);
    // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
  });
}